// extracted by mini-css-extract-plugin
export var filterIncDec = "_bb-0";
export var leftBorder = "_bb-1";
export var rightBorder = "_bb-2";
export var stringInput = "_bb-3";